import React from "react";
import Breadcrumbs from "../components/Breadcrumbs";
import Product from "../components/Product";
import PPEForm from "../components/PPEForm";
import Specifications from "../components/Specifications";

// Import data from helpers
import { handSanitizerProducts } from "../helpers/hand-sanitizer/products";
import { handSanitizerFormFields } from "../helpers/hand-sanitizer/formConfig";
import { handSanitizerSpecifications } from "../helpers/hand-sanitizer/specifications";

const HandSanitizer: React.FC = () => {
  // Breadcrumb data
  const breadcrumbItems = [
    {
      label: "Hand Sanitizer",
      path: "/hand-sanitizer",
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow">
        {/* Breadcrumbs */}
        <Breadcrumbs items={breadcrumbItems} />

        {/* Page Title and Products - Unified Container */}
        <div className="w-full py-8 bg-white">
          <div className="page-container">
            <h1 className="page-title">
              Hand Sanitizer in Bulk
            </h1>
            <p className="page-description">
              We offer a variety of hand sanitizer solutions to meet your needs.
              Choose from liquid, gel or hand wipes branded with your logo or
              blank. Hand sanitizers come in a wide selection of ounce sizes,
              sprays, canisters, pumps and packets. We also offer hand
              sanitizing stations that can be setup at your business or event.
              Our hand sanitizers meet FDA requirements and contain at least 60%
              alcohol. Simply request a quote and we will send our best options
              and pricing.
            </p>
            
            {/* Product Grid */}
            <div className="mt-8">
              <Product products={handSanitizerProducts} aspectRatio="sanitizer" />
            </div>
          </div>
        </div>

        {/* Get Started Form */}
        <PPEForm
          title="Get Started"
          description="Get in touch today or call"
          phoneNumber="877-927-3691"
          fields={handSanitizerFormFields}
          formName="Hand Sanitizer PPE.us"
        />

        {/* Sanitizer Specifications */}
        <Specifications
          title="Sanitizer Specifications"
          items={handSanitizerSpecifications}
        />
      </main>
    </div>
  );
};

export default HandSanitizer;
